<template>
    <div class="container-login form-login-meio">
        <div class="p-d-flex p-jc-center"> 
            <div>
                <div class="p-d-flex p-jc-center p-mb-5">
                    <a href="/login">
                        <img alt="Logo" src="@/assets/logo.png" />
                    </a>
                </div>
                <div class="card p-fluid p-shadow-3" style="width: 25rem;">
                    <h5 class="p-pt-4 p-d-flex p-jc-center">Redefinir senha</h5>                  
                    <div class="p-field p-mt-4">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />                       
                            <InputText v-model.trim="senha" type="password" placeholder="Nova senha" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="senha === '' && enviandoForm">Informe a senha</small>  
                    </div>
                    <div class="p-field">					
                        <span class="p-input-icon-left">
                            <i class="pi pi-lock" />                       
                            <InputText v-model.trim="repetirSenha" type="password" placeholder="Repetir senha" aria-describedby="email-erro" />                            
                        </span>
                        <small id="email-erro" class="p-invalid" v-if="repetirSenha === '' && enviandoForm">Informe a senha</small>  
                    </div>   
                    <div class="p-grid p-mt-3 p-mb-4">
                        <div class="p-col-12">
                            <Button label="Enviar" @click="enviar"/>
                        </div>
                    </div>	
                    <Message severity="error" v-if="mensagemErro !== ''">{{ mensagemErro }}</Message>
                    <Message severity="info" v-if="mensagemSucesso !== ''">{{ mensagemSucesso }}</Message>
                </div>
                <div class="p-text-center" style="color:#F9B720">Info Kings</div>
                <div v-if="exibirSpin" class="p-text-center"><i class="pi pi-spin pi-spinner" style="fontSize: 2rem; color:#F9B720"></i></div>
            </div>
        </div>
    </div> 
</template>

<script>
import LoginService from '@/service/LoginService';

export default {
    loginService: null,  
    data() {
        return {            
            exibirSpin: false,
            enviandoForm: false,           
            mensagemErro: '',
            mensagemSucesso: '',            
            email: '',
            senha: '',
            repetirSenha: '',
            time: '',
            token: '',
        }
    },    
    methods: {
        enviar() {
            this.exibirSpin = true;
            this.enviandoForm = true;         
            this.mensagemSucesso = '';
            this.mensagemErro = '';                         
            if(this.senha != '' && this.repetirSenha != '') {         
                let dados = {
                    email: this.email,
                    senha: this.senha,
                    repetirSenha: this.repetirSenha,
                    time: this.time,
                    token: this.token,
                }   
                this.loginService.redefinirSenha(dados)
                    .then(resp => {
                        this.exibirSpin = false;                       
                        this.mensagemSucesso = resp.data.mensagem;
                    })
                    .catch(erro => {       
                        this.exibirSpin = false;     
                        this.mensagemErro = erro.response.data.mensagem;
                    });               
            } else {
                this.exibirSpin = false;
            }           
        },
        validarParametrosURL() {
            let query = this.$route.query;       
            if(query.em === undefined || query.tm === undefined || query.tk === undefined || isNaN(query.tm)) {
                this.$router.push('/erro404');                
            } else {
                this.email = query.em;
                this.token = query.tk;
                this.time = query.tm;
            }
        }    
    },
    created() {
        this.loginService = new LoginService();    
        this.validarParametrosURL();        
    }
}
</script>

<style scoped>    
    
    html, body {
        height: 100vh !important;
        margin: 0px !important;  
    }

    .container-login {
        height: 100vh !important;
        background-color: #232839 !important;
    }

    .form-login-meio {
        padding-top: 130px;
    }

    .text-help {
        font-size: 0.9rem !important;
    }

</style>